<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:28:49
 * @FilePath: \zhucai_user\src\pages\member\child\course.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的课程</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.Title"
            placeholder="输入关键词搜索"
          />
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="date" label="课程名称">
          <template slot-scope="scope">
            <div class="course-box">
              <div class="img">
                <img :src="scope.row.ImgPath" @error="imgError" />
              </div>
              <div class="flex1">
                <p class="CourseName">{{ scope.row.CourseName }}</p>
                <p class="ChapterName">
                  <img src="@/assets/img/member/37.png" />{{
                    scope.row.ChapterName
                  }}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ClassifyName"
          label="分类"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ValidityTimeTxt"
          label="有效期"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="StudyProgress"
          label="学习进度"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span class="StudyProgress">{{ scope.row.StudyProgress }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="GetScore"
          label="分数"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span class="StudyProgress">{{ scope.row.GetScore }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="toCourse(scope.row)">
              学习
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { GetMyCourseList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "MyMap",
  data() {
    return {
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        PageIndex: 1,
        PageSize: 5,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    toCourse(data) {
      this.$router.push({
        path: "/courseDetail",
        query: {
          CourseID: data.CourseID,
        },
      });
      // this.$router.push({
      //   path: "/chapterDetail",
      //   query: {
      //     CourseID: data.CourseID,
      //     ChapterID: data.ChapterID,
      //   },
      // });
    },

    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetMyCourseList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.course-box {
  display: flex;
  gap: 20px;
  .img {
    width: 150px;
    height: 112px;
    border-radius: 6px;
  }
  .CourseName {
    margin: 10px 0;
    font-size: 20px;
    color: #333333;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .ChapterName {
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
    padding: 5px 10px;
    font-size: 16px;
    color: #1d79ff;
    background: #e5f0ff;
    border-radius: 6px;
    img {
      width: 22px;
      height: 22px;
    }
  }
}
.StudyProgress {
  font-weight: 900;
  font-size: 18px;
  color: #1d79ff;
}
</style>
